import { render, staticRenderFns } from "./FollowUpsTable.vue?vue&type=template&id=a60bd798&"
import script from "./FollowUpsTable.vue?vue&type=script&lang=js&"
export * from "./FollowUpsTable.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports